import { makeStyles } from '@mui/styles';

const styles = (theme) => ({

  root: () => {
    return  {
        display: 'block',
        position: 'relative',
        width: '112px',
        minHeight: '148px',
    };
  },

  renderIfVisible: {
    display: 'block',
    position: 'relative',
    width: '100%',
    minHeight: '100%',

    '& .renderIfVisible-placeholder': {
      display: 'block',
      position: 'relative',
      width: '100%',
      minHeight: '100%',
    },
  },

  overlay: () => {
    return {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '100%',
        position: 'absolute',
        top: 0,
        left: 0,
        backgroundColor: 'transparent',
        pointerEvents: 'none',
    };
  },

  thumbnail: () => {
    return  {
        display: 'flex',
        top: 0,
        left: 0,
        flexDirection: 'column !important',
        width: '100%',
        minHeight: '100%',
        justifyContent: 'center',
        alignItems: 'center',

        '&:hover': {
          cursor: 'pointer',
        }
    };
  },

  buttonContainer: () => {
    return  {
      flexDirection: 'column !important',
      width: '100%',
      minHeight: '100%',
      justifyContent: 'center',
      alignItems: 'center',

      '&:hover': {
        backgroundColor: 'transparent !important',
      },

      '&:MuiMenuItem-root': {
        fontFamily: theme.typography.fontFamily,
      },
    };
  },

  text: ({ commonUIStyles, selected, widget, view  }) => {
    return  {
      ...commonUIStyles.thumbnailText({selected, widget, view}),
      // ...getAriaSelection(),
      color: selected ? commonUIStyles.getPrimaryButtonColor(widget) : '#000000',
      // width: '72px',
      marginTop: '6px',
      marginBottom: '1px',

      height: '42px',
      lineHeight: '14px',

      overflow: 'hidden',
      display: '-webkit-box',
      '-webkit-line-clamp': 3,
      '-webkit-box-orient': 'vertical',
      textOverflow: 'ellipsis',

      fontSize: '12px',
      textAlign: 'center',
      backgroundColor: 'transparent',
      
      fontWeight: '300',
    };
  },

  checkOverlay: {
    display: 'block',
    width: '28px',
    height: '28px',
    position: 'absolute',
    top: '1px',
    left: '80px',
    pointerEvents: 'none',
    backgroundColor: 'transparent',
  },
 
  check: () => {
    
    return {
      pointerEvents: 'none',
    };
  },


});

export default styles;
export const useStyles = makeStyles(styles);
